export function KeyBenefitsSection() {
  const benefits = [
    {
      icon: 'ri-global-line',
      title: 'Acceso inmediato desde cualquier país',
      description: 'Sin restricciones geográficas, comienza hoy mismo'
    },
    {
      icon: 'ri-file-copy-line',
      title: 'Material práctico y replicable',
      description: 'Videos mas de 100 con las estrategias listas para implementar y actualizaciones cada mes'
    },
    {
      icon: 'ri-team-line',
      title: 'Comunidad de apoyo',
      description: 'Conecta con otros estudiantes y mentores'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Mentores con experiencia',
      description: 'Aprende de expertos en ventas digitales de nuestra comunidad'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Recupera tu inversión rápido',
      description: 'Resultados en tiempo récord con nuestra metodología'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantía de satisfacción',
      description: 'garantia de por vida'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">Beneficios clave</h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Transforma tu conocimiento en una fuente de ingresos constante
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group p-8 rounded-2xl bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className={`${benefit.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              <div className="mt-4 flex items-center gap-2 text-emerald-600 font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-sm whitespace-nowrap">Más información</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center p-12 rounded-3xl bg-gradient-to-r from-emerald-50 to-cyan-50 border-2 border-emerald-200">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">¿Listo para comenzar tu transformación digital?</h3>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Únete a cientos de estudiantes que ya están generando ingresos con nuestras estrategias probadas
          </p>
          <a
            href="https://chat.whatsapp.com/D1ddDVG4KWTK9K7vPP9RsZ?mode=gi_t"
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-4 rounded-xl font-bold text-lg bg-gradient-to-r from-emerald-500 to-cyan-500 text-white hover:shadow-2xl hover:shadow-emerald-500/50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-block"
          >
            Unirme a la Comunidad →
          </a>
        </div>
      </div>
    </section>
  );
}
